import { Routes } from '@angular/router';

import { PermissionStoreModelEnum } from '@domain/profile';

import { RouteSegments } from '@shared/enums';
import { authGuard } from '@shared/guards/auth';
import { dashboardGuard } from '@shared/guards/dashboard';
import { permissionGuard } from '@shared/guards/permission';
import { profileGuard } from '@shared/guards/profile';

export const routes: Routes = [
  {
    canActivate: [authGuard, profileGuard, dashboardGuard],
    path: RouteSegments.Root,
    pathMatch: 'full',
    loadChildren: () => import('./pages/dashboard/dashboard-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.Capacity,
    loadChildren: () => import('./pages/capacity/capacity-routes').then(({ routes }) => routes),
  },
  {
    path: `${RouteSegments.Public}`,
    loadChildren: () => import('./pages/public/public-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.TransmissionRights,
    loadChildren: () => import('./pages/trs/trs-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.Nominations,
    loadChildren: () => import('./pages/nominations/nominations-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.Reports,
    loadChildren: () => import('./pages/reports/reports-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.CrisisManagement,
    loadChildren: () => import('./pages/crisis-management/crisis-management-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.Organisation,
    loadChildren: () => import('./pages/organisation/organisation-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.Admin,
    loadChildren: () => import('./pages/admin/admin-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.AuditLogs,
    loadChildren: () => import('./pages/audit-logs/audit-logs-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.Account,
    loadChildren: () => import('./pages/account/account-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.ImbalanceTrading,
    loadChildren: () => import('./pages/imbalance-trading/imbalance-trading-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.DataFlow,
    loadChildren: () => import('./pages/data-flow/data-flow-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.NominationUpload,
    loadChildren: () => import('./pages/manual-file-upload/manual-file-upload-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [authGuard, profileGuard],
    path: RouteSegments.Messages,
    loadChildren: () => import('./pages/messages/messages-routes').then(({ routes }) => routes),
  },
  {
    canActivate: [
      authGuard,
      profileGuard,
      permissionGuard([PermissionStoreModelEnum.MANAGE_DMV_OVERRIDES, PermissionStoreModelEnum.VIEW_DMV_OVERRIDES]),
    ],
    path: RouteSegments.Settlement,
    loadChildren: () => import('./pages/settlement/settlement-routes').then(({ routes }) => routes),
  },
  {
    path: RouteSegments.WildCard,
    redirectTo: RouteSegments.Root,
  },
];
